<div class="library-results-main"
    infiniteScroll
    [infiniteScrollDistance]="0.01"
    [infiniteScrollThrottle]="250"
    (scrolled)="onScroll()"
>
    <ul class="results">
        <li class="result-item" *ngFor="let version of items" >
            <versions-summary-status-box
                [version]="version"
                [exclude]="excludedLabels"
                [feedbacks]="getFeedbacks(version)"
                [menu]="menu"
                (menuClick)="onMenuClick($event)"
                (actionFileClick)="onFileClick(version,$event)"
                (actionLabelClick)="onLabelClick($event)"
                (menuStatusClick)="updateVersionStatus($event,version)"
            ></versions-summary-status-box>
        </li>
        <!-- artworks pagination wheel -->
        <li class="loading-more" [hidden]="!loadingMore || resultsStatus == SEARCH_STATUS.FINAL">
            <core-helpers-box-loading ></core-helpers-box-loading>
        </li>
    </ul>
    <!-- <p> STATUS INITIAL </p> -->
    <div class="loader" [hidden]="!(resultsStatus == SEARCH_STATUS.LOADING && items.length == 0) && resultsStatus != SEARCH_STATUS.INITIAL">
        <div class="dimmed dimmed_list_main">
            <div class="dimmed_table_box"></div>
            <div class="dimmed_table_box"></div>
            <div class="dimmed_table_box"></div>
            <div class="dimmed_table_box"></div>
            <div class="dimmed_table_box"></div>
        </div>
        <!-- <core-helpers-box-loading ></core-helpers-box-loading>   -->
    </div>

     <!--  to review how to not show this when term changed and result items did not arrive yet... a wheel? -->
    <core-helpers-box-alert-message-icon [hidden]="!(items.length == 0) || !hasSearch || resultsStatus == SEARCH_STATUS.LOADING || resultsStatus == SEARCH_STATUS.INITIAL"
        [text]="'There are no matches for your query. Try removing filters or typing a new query.'"
        [icon]="'warning'"
    ></core-helpers-box-alert-message-icon>
    <core-helpers-box-alert-message-icon [hidden]="!(resultsStatus == SEARCH_STATUS.FINAL && items.length == 0 && !hasSearch)"
        [text]="'There are no artworks.'"
        [icon]="'warning'"
    ></core-helpers-box-alert-message-icon>
</div>
